/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';

// Rendered as inline SVG (rather than an <img src="...svg">) with fill="currentColor" so the
// icon follows .resourceButton's `color` the same way the FontAwesome glyph icons do, keeping
// contrast correct across themes/high-contrast modes instead of a hard-coded fill color.
function PciToolIcon({ className }) {
    return (
        <svg
            className={className}
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
        >
            <path
                d="M1.95213 13.6859V11.8014H3.83658V13.6859H1.95213ZM24.1634 13.6859V11.8014H26.0479V13.6859H24.1634ZM1.95213 9.2435V7.35904H3.83658V9.2435H1.95213ZM24.1634 9.2435V7.35904H26.0479V9.2435H24.1634ZM1.95213 4.80142V2.91667H3.83658V4.80142H1.95213ZM6.39421 13.6859V11.8014H8.27896V13.6859H6.39421ZM19.721 13.6859V11.8014H21.6058V13.6859H19.721ZM24.1634 4.80142V2.91667H26.0479V4.80142H24.1634ZM6.39421 4.80142V2.91667H8.27896V4.80142H6.39421ZM10.8366 4.80142V2.91667H12.721V4.80142H10.8366ZM15.279 4.80142V2.91667H17.1634V4.80142H15.279ZM19.721 4.80142V2.91667H21.6058V4.80142H19.721ZM13.7043 25.947C13.2763 25.947 12.8689 25.8669 12.4822 25.7069C12.0956 25.5469 11.7491 25.3142 11.4427 25.009L5.92754 19.4857L6.74421 18.6398C6.97151 18.4123 7.24228 18.2631 7.5565 18.1921C7.87053 18.1212 8.18835 18.1268 8.50996 18.209L10.7018 18.7699V9.33333C10.7018 9.08542 10.7857 8.87765 10.9535 8.71004C11.1213 8.54224 11.3293 8.45833 11.5774 8.45833C11.8253 8.45833 12.0331 8.54224 12.2007 8.71004C12.3681 8.87765 12.4518 9.08542 12.4518 9.33333V21.0875L9.13354 20.2035L12.6761 23.7685C12.8227 23.9151 12.9809 24.0232 13.1507 24.0928C13.3204 24.1622 13.5055 24.197 13.706 24.197H18.1732C18.8949 24.197 19.5129 23.94 20.027 23.4261C20.5411 22.912 20.7982 22.2939 20.7982 21.572V17.3877C20.7982 17.1398 20.8821 16.932 21.0499 16.7644C21.2175 16.5966 21.4253 16.5127 21.6735 16.5127C21.9214 16.5127 22.1291 16.5966 22.2968 16.7644C22.4642 16.932 22.5479 17.1398 22.5479 17.3877V21.572C22.5479 22.7806 22.1209 23.812 21.2669 24.666C20.4129 25.52 19.3816 25.947 18.1732 25.947H13.7043ZM14.0674 18.1169V13.4391C14.0674 13.1912 14.1513 12.9833 14.3191 12.8155C14.4869 12.6479 14.6948 12.5641 14.9427 12.5641C15.1908 12.5641 15.3985 12.6479 15.566 12.8155C15.7336 12.9833 15.8174 13.1912 15.8174 13.4391V18.1169H14.0674ZM17.4326 18.1169V14.8301C17.4326 14.5822 17.5165 14.3744 17.6843 14.2068C17.8521 14.039 18.06 13.9551 18.3079 13.9551C18.556 13.9551 18.7639 14.039 18.9315 14.2068C19.0989 14.3744 19.1826 14.5822 19.1826 14.8301V18.1169H17.4326Z"
                fill="currentColor"
            />
        </svg>
    );
}

PciToolIcon.propTypes = {
    className: PropTypes.string,
};

PciToolIcon.defaultProps = {
    className: '',
};

export default PciToolIcon;
